import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/containers/Index'
import InfoAdd from '@/containers/info/Add'
import InfoDetail from '@/containers/info/Index'
import infoList from '@/containers/info/List'
import taskDetail from '@/containers/task/Index'
import taskAdd from '@/containers/task/Add'
import userInfo from '@/containers/user/Index'
import Login from '@/containers/user/Login'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/info/add',
      name: 'infoAdd',
      component: InfoAdd
    },
    {
      path: '/info/list',
      name: 'infoList',
      component: infoList
    },
    {
      path: '/info/:id',
      name: 'infoDetail',
      component: InfoDetail
    },
    {
      path: '/task/add',
      name: 'taskAdd',
      component: taskAdd
    },
    {
      path: '/task/:id',
      name: 'taskDetail',
      component: taskDetail
    },
    {
      path: '/my',
      name: 'my',
      component: userInfo
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js